import { RequestFormattedStatus } from "./measure-detail/approval-request/enums";

;

export interface ApprovalStatusConfig {
    emoji?: string;
    icon?: string;
    text: string;
    class: string;
    iconColor?: string;
}

export class ApprovalStatusConfigFactory {
    static createConfig(dataService: any): Partial<Record<RequestFormattedStatus, ApprovalStatusConfig>> {
        return {
            [RequestFormattedStatus.REVIEW_CORE_TEAM]: {
                emoji: '⏳',
                text: dataService.res("Ubt-Measure-List-Approval-Request-" + RequestFormattedStatus.REVIEW_CORE_TEAM),
                class: 'approval-pending',
            },
            [RequestFormattedStatus.REVIEW_STEERING_COMMITTEE]: {
                emoji: '⏳',
                text: dataService.res("Ubt-Measure-List-Approval-Request-" + RequestFormattedStatus.REVIEW_STEERING_COMMITTEE),
                class: 'approval-pending',
            },
            [RequestFormattedStatus.WITHDRAWN]: {
                icon: 'undo',
                text: dataService.res("Ubt-Measure-List-Approval-Request-" + RequestFormattedStatus.WITHDRAWN),
                class: 'approval-rejected',
                iconColor: '#991b1b'
            },
            [RequestFormattedStatus.REJECTED]: {
                icon: 'close',
                text: dataService.res("Ubt-Measure-List-Approval-Request-" + RequestFormattedStatus.REJECTED),
                class: 'approval-rejected',
                iconColor: '#991b1b'
            },

        };
    }
}